import { useEffect } from 'react';
import useStores from '$src/hooks/useStores';
import { useParams } from 'react-router';
import { controlCenterApi } from '$src/api/control-center-api';
import { sendCloudwatchRUMError } from '$src/utils/cloudwatchRUM';
import { LocationPrincipalDomain } from '$src/api/constants';

function useLocationContext() {
  const { locationId: paramsLocationId } = useParams();
  const { sessionStore, locationContextStore } = useStores();

  const shouldUpdateLocation = paramsLocationId && locationContextStore.location?.locationId !== paramsLocationId;

  useEffect(() => {
    async function fetch(locationId) {
      sessionStore.setLoading(true);
      try {
        const response = await controlCenterApi.fetchFeatures(LocationPrincipalDomain, locationId);
        sessionStore.setFeatureFlags(response, LocationPrincipalDomain);
      } catch (error) {
        sendCloudwatchRUMError(`There was an error fetching features for principalDomain=${LocationPrincipalDomain} principal=${locationId}`, error);
      }

      await locationContextStore.fetchLocation(sessionStore.user.user_id, locationId);
      sessionStore.setLoading(false);
    }

    if (shouldUpdateLocation) fetch(paramsLocationId);
  }, [sessionStore, locationContextStore, shouldUpdateLocation, paramsLocationId]);

  return paramsLocationId;
}

export default useLocationContext;
